export const getAction = type => {
  return {
    type: 'Get'.concat(type),
  };
};

export const prependAction = (type, payload) => {
  return {
    type: 'Prepend'.concat(type),
    payload,
  };
};

export const insertAction = (type, payload) => {
  return {
    type: 'Insert'.concat(type),
    payload,
  };
};

export const deleteAction = (type, payload) => {
  return {
    type: 'Delete'.concat(type),
    payload,
  };
};

export const clearAction = type => {
  return {
    type: 'Clear'.concat(type),
  };
};

export const updateAction = (type, updatedResult) => {
  return {
    type: 'Update'.concat(type),
    updatedResult,
  };
};

export const updateEntitiesAction = (entityToUpdate, entity) => {
  return {
    type: 'UpdateEntities',
    entityToUpdate,
    entity,
  };
};

export const setIsLoading = (type, isLoading) => {
  return {
    type: 'SetIsLoading'.concat(type),
    payload: isLoading,
  };
};
